import cn from 'classnames';

const mergeClassNames = (classNames, classes, ...propNames) => ({
  ...classNames,
  ...propNames.reduce((props, propName) => ({
    ...props,
    [propName]: cn(classNames[propName], classes[propName]),
  }), {}),
});

export const mergeTitleAndCopyAndOverlayClassNames = (classNames, classes) => mergeClassNames(classNames, classes, 'title', 'copy', 'overlayTitle', 'overlayContainer');

export default mergeClassNames;
